export default async () => {
  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    return devices;
  } catch {
    return [];
  }
};
